import React, { useState, useEffect } from 'react';

const GoTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add scroll event listener to window
    window.addEventListener('scroll', toggleVisibility);

    return () => {
      // Remove the event listener when the component is unmounted
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const toggleVisibility = () => {
    if (window.scrollY > 10) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  return (
    <a href="#top" className={`go-top ${isVisible ? 'active' : ''}`} title="Go to Top">
      <ion-icon name="arrow-up" role="img" aria-label="arrow up"></ion-icon>
    </a>
  );
};

export default GoTop;
